import React from "react";
import { Link } from "react-router-dom";
import { Zap, ChevronRight, Upload, Users, BarChart3, Gavel, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Shell for /tutorial/quickstart — 5 actions clés en 5 minutes.
 * Contenu complet viendra lors d'un prompt ultérieur (T-3 ou dédié).
 */
export default function QuickStart() {
  const steps = [
    { icon: Users,     title: "1. Créer un projet",           ch: 1 },
    { icon: Upload,    title: "2. Importer un PDF",           ch: 2 },
    { icon: BarChart3, title: "3. Lancer l'analyse vitaliste", ch: 4 },
    { icon: Gavel,     title: "4. Voir l'analyse juridique",  ch: 6 },
    { icon: Download,  title: "5. Exporter le rapport",       ch: 8 },
  ];

  return (
    <div data-testid="tutorial-quickstart" className="space-y-8">
      <header>
        <div className="inline-flex items-center gap-2 rounded-full border border-brand-gold/40 bg-brand-gold/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-brand-gold">
          <Zap className="h-3.5 w-3.5" />
          Démarrage rapide · 5 min
        </div>
        <h1 className="mt-3 font-judicial text-3xl font-black leading-tight tracking-tight sm:text-4xl">
          Maîtriser l'essentiel en 5 minutes
        </h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Les cinq actions clés pour passer d'un PDF budgétaire à un rapport
          vitaliste complet.
        </p>
      </header>

      <ol className="space-y-3">
        {steps.map((s) => {
          const Icon = s.icon;
          return (
            <li
              key={s.ch}
              className="flex items-center gap-4 rounded-lg border border-border bg-card p-4 transition-shadow hover:shadow-sm"
              data-testid={`quickstart-step-${s.ch}`}
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-blue text-white dark:bg-brand-gold dark:text-background">
                <Icon className="h-5 w-5" />
              </span>
              <span className="flex-1 text-sm font-medium">{s.title}</span>
              <Link to={`/tutorial/chapter/${s.ch}`}>
                <Button variant="outline" size="sm">
                  Voir le chapitre
                  <ChevronRight className="ml-1 h-4 w-4" />
                </Button>
              </Link>
            </li>
          );
        })}
      </ol>

      <div className="rounded-md border border-dashed border-border/70 bg-muted/30 p-5 text-sm text-muted-foreground">
        [Contenu détaillé du démarrage rapide — à enrichir lors d'un prompt ultérieur]
      </div>
    </div>
  );
}
